import { render, staticRenderFns } from "./booksdonate.vue?vue&type=template&id=9448b32a&scoped=true&"
import script from "./booksdonate.vue?vue&type=script&lang=js&"
export * from "./booksdonate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9448b32a",
  null
  
)

component.options.__file = "booksdonate.vue"
export default component.exports